<div
  class="acct-alerts transition collapsed"
  [class.expanded]="alert?.length && toggleAlerts"
  *ngIf="customerNotifications"
>
  <div
    class="expanded-blade"
    *ngIf="
      (showIndicators &&
        (customerNotifications?.paymentArrangementIndicator ||
          customerNotifications?.epsIndicator)) ||
      alert?.length
    "
  >
    <ng-container *ngIf="showIndicators && customerNotifications?.paymentArrangementIndicator">
      <div class="row m-t-md">
        <div class="col-10 col-md-11">
          <p class="alert-text">
            <i class="fa fa-flag def alert-icon"></i>{{ contentData?.activePaymentArrangement }}
          </p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showIndicators && customerNotifications?.epsIndicator">
      <div class="row m-t-md">
        <div class="col-10 col-md-11">
          <p class="alert-text">
            <i class="fa fa-flag def alert-icon"></i>{{ contentData?.extendedPaymentSchedule }}
          </p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="alert?.length && toggleAlerts">
      <ng-container *ngFor="let item of alert; let idx = index">
        <div
          class="row m-t-xl p-b-md m-l-lg"
          [class.p-b-xl]="idx <= alert?.length"
          *ngIf="idx < maxAlertLimit"
        >
          <div class="col-10 col-md-11 alert-wrapper">
            <p class="alert-text">
              <span [innerHTML]="item?.text"></span>
            </p>
          </div>
          <div class="col-2 col-md-1 text-end">
            <a
              class="hover-magenta"
              (keyup.enter)="removeAlert(idx)"
              [attr.aria-label]="item?.text + ' ' + contentData?.selectToDismiss"
              href="javascript:void(0)"
              id="cta-select-to-dismiss_{{ idx }}"
            >
              <i class="fa fa-times-circle def close-notification" (click)="removeAlert(idx)"></i>
            </a>
          </div>
        </div>
        <hr class="m-l-lg" *ngIf="idx < alert?.length - 1" />
      </ng-container>
      <ng-container *ngIf="alert?.length > defaultAlertLimit">
        <div class="row">
          <div class="col-12">
            <p class="small m-t-md m-b-lg m-l-lg">
              <ng-container *ngIf="!showAllAlert; else seeLess">
                <a
                  href="javascript:void(0)"
                  [attr.aria-label]="contentData?.seeMoreAlerts"
                  (click)="showAll()"
                  id="cta-see-more-alerts"
                  >{{ contentData?.seeAll }}</a
                >
              </ng-container>
              <ng-template #seeLess>
                <a
                  href="javascript:void(0)"
                  [attr.aria-label]="contentData?.seeLessAlerts"
                  (click)="showAll()"
                  id="cta-see-less-alerts"
                  >{{ contentData?.seeLess }}</a
                >
              </ng-template>
            </p>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
